<!-- <div id="overlay" *ngIf="iSLoading">
  <div id="loading-center">
      <div id="loading-center-absolute">
          <div class="object" id="object_four"></div>
          <div class="object" id="object_three"></div>
          <div class="object" id="object_two"></div>
          <div class="object" id="object_one"></div>
      </div>
  </div>
  </div> -->

<div class="wrapper">
  
<!--Header Here-->
<app-header></app-header>
<!--Header Here-->

<!-- Full Width Column -->
<div class="content-wrapper">
  <div class="container">
    <!-- Content Header (Page header) -->
    <!-- <section class="content-header">
            
    </section> -->

    <!-- Main content  content-->
    <section class="">
       
      <router-outlet></router-outlet> 
      
      <!-- /.box -->
    </section>
    <!-- /.content -->
  </div>
  <!-- /.container -->
</div>
<!-- /.content-wrapper -->

<!-- Footer Here - Start -->
<app-footer></app-footer>
<!-- Footer Here - End -->
</div>
<!-- ./wrapper -->

